import store from "../store";

export default (to, from, next) => {
  const selectedCompany = store.getters["company/selectedCompany"];

  try {
    if (!selectedCompany) {
      return next({ path: "/" });
    }

    if (to.meta.permission) {
      const userHasPermission = store.getters["auth/hasPermission"];
      if (!userHasPermission(to.meta.permission)) throw new Error();
    }

    next();
  } catch {
    return next({ path: "/" });
  }
};
